/** @format */

import { useEffect } from "react";
import {
  UBER_AUTH_CLIENT_ID,
  UBER_AUTH_RESPONSE_TYPE,
  UBER_AUTH_REDIRECT_PORTAL_LOGIN_PATH,
} from "../config/config";
import Loader from "../shared/components/Loader";

const UberAuthRedirect = () => {
  useEffect(() => {
    window.location.href = `https://login.uber.com/oauth/v2/authorize?client_id=${UBER_AUTH_CLIENT_ID}&response_type=${UBER_AUTH_RESPONSE_TYPE}&redirect_uri=${window
      .location.origin + UBER_AUTH_REDIRECT_PORTAL_LOGIN_PATH}`;
  }, []);

  return <Loader blackbg={true} text="Redirecting to Uber... " />;
};

export default UberAuthRedirect;
